import React, { useMemo } from 'react'
import { Row, Paragraph, Button, Separator, Divider, colors } from '@fs/zion-ui'
import { HelpAi } from '@fs/zion-icon'
import { useTranslation } from 'react-i18next'
import { hasTranscript, useSlsStateContext, getImage } from '@fs/zion-sls'
import { useFullTextStateContext } from '../../../fullText/providers/FullTextContext'

export default function TranscriptAlertBanner({ handleViewTranscript }) {
  const [t] = useTranslation()
  const fullTextState = useFullTextStateContext()
  const zionSlsState = useSlsStateContext()

  const currentImage = useMemo(
    () => getImage(zionSlsState.images, zionSlsState.currentImageArk),
    [zionSlsState.images, zionSlsState.currentImageArk]
  )

  const showTranscript = useMemo(() => {
    return hasTranscript(currentImage?.elements)
  }, [currentImage])

  if (!fullTextState.imagePermission || !showTranscript) return null

  return (
    <>
      <Divider fullWidth />
      <Separator size="xxs" />
      <Row alignX="end" alignY="middle" wrap={false} guttersX="xs">
        <Row alignY="middle" guttersX="xs" growX>
          <HelpAi size="xs" color="white" background={colors.purple50} />
          <Paragraph size="sm">{t('select-person.transcript-banner', 'AI-generated transcript available.')}</Paragraph>
        </Row>
        <Button
          emphasis="low"
          color="blue"
          onClick={handleViewTranscript}
          linkName="View Transcript"
          data-testid="view-transcript-button"
        >
          {t('select-person.view-transcript', 'VIEW')}
        </Button>
      </Row>
      <Separator size="xxs" />
      <Divider fullWidth />
    </>
  )
}
